import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/goodsorder/page', data, {
    trim: true
  })
}
export function fetchShopList (data) {
  return request.post('/business/goodsorder/pageShop', data, {
    trim: true
  })
}
export function shopTotalData (data) {
  return request.post('/business/goodsorder/shopTotalData', data, {
    trim: true
  })
}

// 导出Excel
export function exportExcel (data) {
  return request.post('/business/goodsorder/exportExcel', data, {
    trim: true,
    download: true
  })
}

// 修改
export function updateById (data) {
  return request.post('/business/goodsorder/updateById', data)
}

// 修改
export function orderRemark (data) {
  return request.post('/business/goodsorder/orderRemark', data)
}
export function orderPlanCancelOrder (data) {
  return request.post('/business/goodsorder/orderPlanCancelOrder', data)
}
export function orderRefund (data) {
  return request.post('/business/goodsorder/orderRefund', data)
}
export function orderSendOutGoods (data) {
  return request.post('/business/goodsorder/orderSendOutGoods', data)
}
export function detail (id) {
  return request.get(`/business/goodsorder/${id}`)
}
